'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { FlexColumn } from 'src/components/Atoms/FlexBox';
import { ContentPanel } from 'src/components/Molecules/ContentPanel';
import { Loading } from 'src/components/Organisms/Loading';
import { styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
interface CompanyProps {
  isLoading?: boolean;
  loadingMessage?: string;
  backgroundImage?: string;
  children?: React.ReactNode;
}
const SplitPage = styled(FlexColumn)(() => ({
  alignItems: 'flex-start',
  backgroundColor: 'var(--effektify-surface-secondary)',
  flexDirection: 'row',
  gap: 'var(--effektify-spacing-07)',
  padding: 'var(--effektify-spacing-07)',
  width: '100%',
  height: '100vh'
}));
const FallBackImage = '/images/signin-img-v1.webp';
function Company(t0) {
  const $ = _c(10);
  const {
    isLoading,
    loadingMessage: t1,
    backgroundImage: t2,
    children
  } = t0;
  const loadingMessage = t1 === undefined ? "" : t1;
  const backgroundImage = t2 === undefined ? FallBackImage : t2;
  const isScreenSmall = useMediaQuery(_temp);
  let t3;
  if ($[0] !== isLoading || $[1] !== loadingMessage) {
    t3 = isLoading && <Loading message={loadingMessage} />;
    $[0] = isLoading;
    $[1] = loadingMessage;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = !isLoading && children;
  let t5;
  if ($[3] !== backgroundImage || $[4] !== isScreenSmall) {
    t5 = !isScreenSmall && <ContentPanel backgroundImage={backgroundImage} />;
    $[3] = backgroundImage;
    $[4] = isScreenSmall;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = <SplitPage>{t3}{t4}{t5}</SplitPage>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp(theme) {
  return theme.breakpoints.down("md");
}
;
export default Company;
export type { CompanyProps };